export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
export const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+.,/?;:{}[\]\-=`~]{8,}$/;
export const phoneRegex = /^[+()\d ]{6,20}$/;
